import type { ReactNode } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { cn } from '@/shared/lib';
import type { DetailAdjacent } from './types';
import { styles } from './styles';

/**
 * The paired prev/next record navigation. Renders as a single grouped pill —
 * the commerce reference shows a two-button cluster wrapped in a darker
 * container so they read as one control.
 *
 * Passing `null` disables one side; both `null` renders nothing (the parent
 * already short-circuits when both are absent).
 */
export function PrevNextNav({ prev, next }: { prev: DetailAdjacent; next: DetailAdjacent }): ReactNode {
  return (
    <div className={styles.navGroup}>
      <button
        type="button"
        onClick={prev ? prev.onClick : undefined}
        disabled={!prev}
        aria-label="Previous record"
        className={styles.navButton}
      >
        <FiChevronLeft size={14} aria-hidden="true" />
      </button>
      <button
        type="button"
        onClick={next ? next.onClick : undefined}
        disabled={!next}
        aria-label="Next record"
        className={cn(styles.navButton, styles.navButtonRight)}
      >
        <FiChevronRight size={14} aria-hidden="true" />
      </button>
    </div>
  );
}